import { array, fn } from '@ember/helper';
import { on } from '@ember/modifier';
import Component from '@glimmer/component';
import includes from '@nullvoxpopuli/ember-composable-helpers/helpers/includes';
import TruncateWithTooltip from 'garaje/components/truncate-with-tooltip';

interface MultiModelSelectorRowSignature<T> {
  Args: {
    item: T;
    selectedItems: T[];
    nameKey: keyof T;
    subLevel?: boolean;
    onSelected: (items: T[]) => void;
  };
}

export default class MultiModelSelectorRow<T extends { id: string }> extends Component<
  MultiModelSelectorRowSignature<T>
> {
  get value(): string {
    return <string>this.args.item[this.args.nameKey];
  }

  <template>
    {{#let (includes @item @selectedItems) as |isSelected|}}
      <li data-test-header-selector-option={{@item.id}} class="p-0" tabindex="-1">
        <label class="ember-power-select-option flex items-center space-x-2">
          <input
            type="checkbox"
            checked={{isSelected}}
            class="block text-base w-3 h-6 {{if @subLevel 'ml-5'}}"
            {{on "click" (fn @onSelected (array @item))}}
          />
          <div class="font-normal text-base truncate {{if isSelected 'text-gem-60' 'text-carbon-70'}}">
            <TruncateWithTooltip @value={{this.value}} @length={{if @subLevel 26 30}} />
          </div>
        </label>
      </li>
    {{/let}}
  </template>
}
